import React, { useEffect, useState } from 'react';

import axios from '../../../AxiosInstance';
import useNotification from '../../../components/notification';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/paths';
import { toSlug } from '../../../utils';

export const SingleProductContext = React.createContext();

export const SingleProductProvider = ({ children }) => {
  const { sendNotification } = useNotification();
  const navigate = useNavigate();
  const [form, setForm] = React.useState(null);
  const [id, setId] = React.useState(null);
  const [editSku, setEditSku] = React.useState({});
  const [addSKUModal, setAddSKUModal] = React.useState(false);
  const [showIngredientModal, setShowIngredientModal] = React.useState(false);
  const [newIngredientValue, setNewIngredientValue] = React.useState('');

  const [productDetail, setProductDetail] = React.useState({});

  const [skus, setSkus] = React.useState([]);

  const [categoriesOption, setCategoriesOption] = useState([]);
  const [ingredientTags, setIngredientTags] = useState([]);
  const [brandsOption, setBrandsOption] = useState([]);
  // METHOD
  React.useEffect(() => {
    fetchCategoriesOption();
    fetchAllIngredients();
    fetchAllBrands();
  }, []);

  React.useEffect(() => {
    if (id && id !== 'add') fetchProduct(id);
  }, [id]);

  const fetchCategoriesOption = async () => {
    axios
      .get('/categories')
      .then((res) => {
        setCategoriesOption(res.data);
      })
      .catch((err) => {
        console.error(err);
        sendNotification({ msg: 'get categories error', variant: 'error' });
      });
  };

  const fetchAllBrands = async () => {
    axios
      .get('/brands')
      .then((res) => setBrandsOption(res.data))
      .catch((err) => {
        console.error(err);
        sendNotification({ msg: 'get brands error', variant: 'error' });
      });
  };

  const fetchAllIngredients = async () => {
    axios
      .get('/tags?type=ingredient')
      .then((res) => {
        setIngredientTags(res.data);
      })
      .catch((err) => {
        console.error(err);
        sendNotification({ msg: 'get ingredients list error', variant: 'error' });
      });
  };

  const fetchProduct = async (id) => {
    axios
      .get(`products/${id}`)
      .then((res) => {
        const data = res.data;
        console.log(res.data);
        setProductDetail({
          coverPic: [{ url: data.mainPic }],

          gallery: data.gallery.map((pic) => {
            return {
              url: pic,
            };
          }),
          brand: data.brand.id,
          product_name: data.name,
          slug: data.slug,
          link_to_product: data.linkToProduct,
          description: data.description,
          category: data.categories.map((cat) => cat.id),
          ingredients: data.ingredients?.map((ing) => ing.id),
          variation_title: data.variationTitle,
        });
        setSkus(
          data.skus.map((sku) => {
            return {
              id: sku.id,
              skuName: sku.name,
              skuImage: sku.skuPic,
              skuImageFiles: sku.skuPic ? [{ url: sku.skuPic }] : null,
              discountPrice: sku.discountPrice,
              mainPrice: sku.mainPrice,
              sku: sku.sku,
              inStock: sku.inStock,
              order: sku.order,
            };
          })
        );
        console.log(skus);
      })
      .catch((err) => {
        console.error(err);
        sendNotification({ msg: 'get product detail error', variant: 'error' });
      });
  };

  const submitSkuHandler = (values) => {
    // console.log(values);
    // console.log(values.skuImageFiles[0].originFileObj);
    if (
      editSku && // 👈 null and undefined check
      Object.keys(editSku).length === 0 &&
      Object.getPrototypeOf(editSku) === Object.prototype
    ) {
      // mode ADD SKU
      const newSku = {
        ...values,
        skuImage: values.skuImageFiles ? URL.createObjectURL(values.skuImageFiles[0]?.originFileObj) : null,
        id: values.sku || values.skuName,
        status: 'add',
      };
      setSkus((skus) => [...skus, newSku]);
    } else {
      // mode edit SKU

      const editedSKU = { id: editSku.id, ...values };
      editedSKU.status = editSku.status ? editSku.status : 'edit';
      // console.log(editedSKU);
      if (editedSKU.skuImageFiles) {
        editedSKU.skuImage =
          editedSKU.skuImageFiles[0]?.url || URL.createObjectURL(values.skuImageFiles[0]?.originFileObj);
      }

      setSkus((skus) => [...skus.map((sku) => (sku.id == editedSKU.id ? editedSKU : sku))]);
    }
    // console.log(newSku);

    setAddSKUModal(false);
  };

  const editSkuHandler = (id) => {
    const editSkuItem = skus.find((sku) => sku.id == id);
    // console.log(editSkuItem);
    setEditSku(editSkuItem ? editSkuItem : {});
    setAddSKUModal(true);
  };

  const cancelModalHandler = () => {
    setEditSku({});
    setAddSKUModal(false);
  };

  const stockChangeHandler = (event, id) => {
    // console.log(event, id);
    setSkus([...skus.map((sku) => (sku.id == id ? { ...sku, inStock: event, status: sku.status || 'edit' } : sku))]);
    // console.log(skus);
  };

  const skuDeleteHandler = (id) => {
    // console.log('heh');
    const deleteSku = skus.find((sku) => sku.id == id);
    if (deleteSku.status == 'add') {
      const temp = [...skus];
      temp.splice(
        temp.findIndex((sku) => sku.id == id),
        1
      );
      setSkus(temp);
    } else {
      // case no status || status !== add
      setSkus([...skus.map((sku) => (sku.id == id ? { ...sku, status: 'delete' } : sku))]);
      // console.log(skus);
    }
  };

  const skuArrowUpHandler = (id) => {
    let newSkus = [...skus];
    let index = skus.findIndex((sku) => sku.id == id);
    if (index > 0) {
      [newSkus[index - 1], newSkus[index]] = [newSkus[index], newSkus[index - 1]];
      setSkus(newSkus);
    }
  };

  const skuArrowDownHandler = (id) => {
    let newSkus = [...skus];
    let index = skus.findIndex((sku) => sku.id == id);
    if (index < skus.length - 1) {
      [newSkus[index], newSkus[index + 1]] = [newSkus[index + 1], newSkus[index]];
      setSkus(newSkus);
    }
  };

  const addNewIngredient = (addNewIngredient) => {
    setNewIngredientValue(addNewIngredient);
    setShowIngredientModal(true);
  };

  const addNewIngredientHandler = async () => {
    // console.log(newIngredientValue);
    try {
      let newIng = await axios.post('/tags', {
        value: newIngredientValue,
        slug: toSlug(newIngredientValue),
        tagTypeId: 1,
      });
      let createdIng = { id: newIng.data.id, value: newIng.data.value };
      // let newd = { id: 9, value: newIngredientValue };
      setIngredientTags([...ingredientTags, createdIng]);
      let prevState = form.getFieldValue('ingredients');
      form.setFieldsValue({ ingredients: [...prevState, createdIng.id] });
      // setProductDetail({ ...productDetail, ingredients: [...productDetail.ingredients, createdIng.id] });
      setShowIngredientModal(false);
      setNewIngredientValue('');
    } catch (err) {
      console.error(err);

      sendNotification({
        msg: err.response.status === 500 ? 'Add new ingredient error' : err.response.data.error,
        variant: 'error',
      });
    }
  };

  const errorFormHandler = ({ values, errorFields, outOfDate }) => {
    sendNotification({ msg: 'อาจระบุข้อมูลไม่ครบถ้วนหรือมีบางอย่างผิดพลาด', variant: 'error' });
  };

  const submitFormHandler = (values) => {
    const formData = new FormData();
    console.log(values);
    console.log(skus);
    if (id === 'add') {
      // add new product and SKU
      formData.append('mainPic', values.coverPic[0].originFileObj);

      if (values.gallery) {
        for (let galPic of values.gallery) {
          formData.append('gallery', galPic.originFileObj);
        }
      }

      for (let sku of skus) {
        if (sku.skuImageFiles) formData.append('skuImageFiles', sku.skuImageFiles[0].originFileObj);
      }
      for (let sku of skus) {
        let newSKU = { ...sku };
        delete newSKU.skuImageFiles;
        formData.append('skus', JSON.stringify(newSKU));
      }
      formData.append('brandId', values.brand);
      formData.append('name', values.product_name);
      formData.append('description', values.description);
      formData.append('slug', values.slug);
      formData.append('linkToProduct', values.link_to_product);
      formData.append('categoryId', values.category[values.category.length - 1]);
      if (values.ingredients) {
        for (let ing of values.ingredients) {
          formData.append('ingredients', ing);
        }
      }
      formData.append('variationTitle', values.variation_title);
      // for (let sku of skus) formData.append('skus', new Blob([JSON.stringify(skus)], { type: 'application/json' }));

      axios
        .post('/products', formData)
        .then((res) => {
          sendNotification({ msg: `Create product success`, variant: 'success' });
          navigate(routeName.PRODUCTS);
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Create Error`, variant: 'error' });
        });
    } else {
      // edit products ==========>
      // first check cover and gallery
      if (!values.coverPic[0].url) formData.append('mainPic', values.coverPic[0].originFileObj);

      for (let galPic of values.gallery) {
        if (!galPic.url) {
          formData.append('gallery', galPic.originFileObj);
          formData.append('galleryArray', 'upload');
        } else {
          formData.append('galleryArray', galPic.url);
        }
      }

      // override all text static field
      formData.append('brandId', values.brand);
      formData.append('name', values.product_name);
      formData.append('description', values.description);
      formData.append('slug', values.slug);
      formData.append('linkToProduct', values.link_to_product);
      formData.append('categoryId', values.category[values.category.length - 1]);
      if (values.ingredients) {
        for (let ing of values.ingredients) {
          formData.append('ingredients', ing);
        }
      }
      formData.append('variationTitle', values.variation_title);
      // console.log(formData);

      // SKU edit manage
      for (let sku of skus) {
        if (sku.skuImageFiles && !sku.skuImageFiles[0].url) {
          formData.append('skuImageFiles', sku.skuImageFiles[0].originFileObj);
        }
        let editSKU = { ...sku };
        delete editSKU.skuImageFiles;
        formData.append('skus', JSON.stringify(editSKU));
      }

      // call PUT API
      axios
        .put(`/products/${id}`, formData)
        .then((res) => {
          sendNotification({ msg: `update product success`, variant: 'success' });
          navigate(routeName.PRODUCTS);
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Update Error`, variant: 'error' });
        });
    }
  };

  return (
    <SingleProductContext.Provider
      value={{
        showIngredientModal,
        setShowIngredientModal,
        addNewIngredientHandler,
        newIngredientValue,
        setNewIngredientValue,
        productDetail,
        ingredientTags,
        categoriesOption,
        skus,
        addNewIngredient,
        skuArrowUpHandler,
        skuArrowDownHandler,
        setSkus,
        cancelModalHandler,
        editSkuHandler,
        submitSkuHandler,
        stockChangeHandler,
        skuDeleteHandler,
        addSKUModal,
        editSku,
        submitFormHandler,
        errorFormHandler,
        setId,
        form,
        setForm,
        brandsOption,
      }}>
      {children}
    </SingleProductContext.Provider>
  );
};
